module.exports = "/assets/5f3a487d57b5ec026d5ff6ce2b8588f8.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos/Z5.png
// module id = 2052
// module chunks = 0